import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import MobileDock from "./MobileDock";
import { Toaster } from "../ui/sonner";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-surface">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <MobileDock />
      <Toaster position="top-center" richColors />
    </div>
  );
}
